export default "__VITE_ASSET__BCHqzqrQ__"